export default __webpack_public_path__ + "fonts/poppins-latin-200-normal.7498246ad20e0ba71240.woff2";